"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  id: -2,
  description: 'All events assigned to you',
  directLinkName: '',
  name: 'My Assignments',
  organizationExposed: true,
  setAuth0UserId: true,
  dashboardData: {
    endDate: null,
    includeArchived: false,
    includeComplete: false,
    searchText: '',
    sortStartDateDesc: true,
    startDate: null,
    statusIds: [],
    tagConditions: [[]],
    auth0UserId: ''
  }
};
exports["default"] = _default;